import {
  RESET_CLUB_PACKAGE_ISFETCHING,
  CLUB_PACKAGE_REQUESTING,
  GET_CLUB_PACKAGE_SUCCESS
} from './constants';

const INITIAL_STATE = {
  data: null,
  isFetching: false
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_CLUB_PACKAGE_ISFETCHING: {
      return {
        ...state,
        isFetching: false
      };
    }
    case CLUB_PACKAGE_REQUESTING: {
      return {
        ...state,
        isFetching: true
      };
    }
    case GET_CLUB_PACKAGE_SUCCESS: {
      const data = { ...state.data };
      data[action.payload.id] = action.payload;
      return {
        data,
        isFetching: false
      };
    }
    default:
      return state;
  }
};

export default reducer;

export const getClubPackageByClubId = (clubPackages, clubId) => {
  if (!clubPackages.data) {
    return null;
  }
  const clubPackageIds = Object.keys(clubPackages.data);
  const clubPackageByClubId = clubPackageIds.find(
    (id) => clubPackages.data[id].clubId === clubId
  );
  if (clubPackageByClubId) {
    return clubPackages.data[clubPackageByClubId];
  }
  return null;
};
